import React from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';

export default function ModalActivityDetail2(props) {
  const activityDetail2 = props.model;
  const { id } = props;

  return (
    <Modal
      title="Nuevo detalle de archivo de actividad"
      model={activityDetail2}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="report/file-detail-report"
      state
      dataForce={{
        file_report_id: id,
      }}
    >
      <TextField
        label="Nombre de la hoja"
        type="text"
        name="sheet_name"
        margin="normal"
        fullWidth
        defaultValue={activityDetail2.sheet_name || ''}
        required
      />
      <TextField
        label="Nombre de la tabla"
        type="text"
        name="table_name"
        margin="normal"
        fullWidth
        defaultValue={activityDetail2.table_name || ''}
      />
      <TextField
        label="Rango 1"
        type="text"
        name="range1"
        margin="normal"
        fullWidth
        defaultValue={activityDetail2.range1 || ''}
      />
      <TextField
        label="Rango 2"
        type="text"
        name="range2"
        margin="normal"
        fullWidth
        defaultValue={activityDetail2.range2 || ''}
      />
      <TextField
        label="Comentario"
        type="text"
        name="comment"
        margin="normal"
        fullWidth
        defaultValue={activityDetail2.comment || ''}
      />
    </Modal>
  );
}
